import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {DateUtility} from "./DateUtility";

interface DateControlProps {
    dateString: string;
    onPreviousDate: () => void;
    onNextDate: () => void;
    onDateChange: (date: Date | null) => void;
}

// react-datepicker clones customInput and injects its own onClick; the shown text is the caller-formatted date, not the picker's value.
let DateControlInput = React.forwardRef<HTMLDivElement, {
    displayText: string;
    onClick?: () => void
}>(function (props, ref) {
    return (
        <div className="date-control-text" ref={ref} onClick={props.onClick}>{props.displayText}</div>
    );
});

export let DateControl = function (props: DateControlProps) {
    return (
        <div className="date-control">
            <img
                className="date-control-calendar-icon"
                src="/static/images/calendar-textcolor.svg"
                alt="Calendar"
            />
            <img
                className="date-control-prev"
                src="/static/images/chevron-left-solid-green.svg"
                alt="Previous date"
                onClick={props.onPreviousDate}
            />
            <DatePicker
                selected={DateUtility.urlDateToJsDate(props.dateString)}
                onChange={(date: Date | null) => props.onDateChange(date)}
                customInput={
                    <DateControlInput
                        displayText={DateUtility.dbDateToDispatchOrderHeaderDate(props.dateString)}
                    />
                }
            />
            <img
                className="date-control-next"
                src="/static/images/chevron-right-solid-green.svg"
                alt="Next date"
                onClick={props.onNextDate}
            />
        </div>
    );
};
